module.exports = __webpack_public_path__ + "img/next.828b8415.png";